import { UseQueryResult, useQuery } from "@tanstack/react-query";
import OrganizationsNotificationMediumValuesResponse from "../../../models/API/responseModels/organizationNotificationMediumValuesResponse.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

function useOrganizationNotificationMediumValues(): UseQueryResult<OrganizationsNotificationMediumValuesResponse> {
  const { authState } = useOktaAuth();
  return useQuery({
    queryKey: ["organizationsNotificationMedium"],
    queryFn: () =>
      axiosInstance
        .get("/v1/organization-notification-settings", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data),
    enabled: !!authState?.accessToken?.accessToken,
    
  });
}
export default useOrganizationNotificationMediumValues;
